module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<p class="page-num">page '+
((__t=( page ))==null?'':_.escape(__t))+
'</p>\n<p>'+
((__t=( text ))==null?'':__t)+
'</p>\n';
}
return __p;
};
